import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { put, select } from "redux-saga/effects";
import { HttpCache, HttpCacheAction, UserSession } from "src/store";

export namespace HttpService {
  const NoCacheHeader = {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  };

  type api = {
    base: string | null | undefined;
    url: string;
    method: string;
    noCacheHeader: boolean;
  };

  const getConfig = function* (
    { base, url, method, noCacheHeader }: api,
    data?: any,
    headers: any = {}
  ) {
    const user: UserSession = yield select((state) => state.UserState);

    if (user.loggedIn) {
      headers.authorization = user.user?.accessToken;
    }

    if (noCacheHeader) {
      headers = { ...headers, ...NoCacheHeader };
    }

    return {
      baseURL: base,
      url,
      method,
      data,
      headers,
    };
  };

  export const Fetch = function* (api: api, data?: any, headers: any = {}) {
    const reqCongif: AxiosRequestConfig = yield getConfig(api, data, headers);
    const cache: HttpCache = yield select((state) => state.HttpCacheState);

    const founded = cache.find(
      (x) => x.key.toLowerCase() === api.url.toLowerCase()
    );

    if (founded) {
      if (founded.expiry < new Date().getTime()) {
        put(HttpCacheAction.removeCache(founded.key));
      } else {
        if (founded.value.response && founded.value.response.data) {
          toast.error(founded.value.response.data);
        }
        throw founded.value;
      }
    }

    try {
      const response: AxiosResponse = yield axios(reqCongif);
      return response;
    } catch (error: any) {
      const axiosError: AxiosError = error;

      if (axiosError.response && axiosError.response.data) {
        toast.error(axiosError.response.data);
      }

      if (axiosError.response?.status === 406) {
        const e = {
          code: axiosError.code,
          config: { ...axiosError.config },
          isAxiosError: axiosError.isAxiosError,
          message: axiosError.message,
          name: axiosError.name,
          request: { ...axiosError.request },
          response: { ...axiosError.response },
          stack: axiosError.stack,
        };

        const cacheTime = +axiosError.response.headers["x-cache-time"] || 60;
        yield put(HttpCacheAction.addCache(api.url, e, cacheTime * 1000));
      }

      throw error;
    }
  };
}
